import AttachmentIcon from '@mui/icons-material/Attachment';
import { CircularProgress, Stack } from '@mui/material';
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import attachmentService from './attachment.service';

export default function AttachmentLink(props) {
	const { attachment } = props;
	if (!attachment) {
		return;
	}

	const download = async (event) => {
		event.preventDefault();
    	event.stopPropagation();

		// Must happen synchronously during the user's click.
		const downloadWindow = window.open('', '_blank');

		if (!downloadWindow) {
			// Popup was blocked.
			console.error('Unable to open download window');
			return;
		}

		try {
			const result = await attachmentService.preDownload(attachment.id);
			const url = result.data.data.url;

			downloadWindow.opener = null;
			downloadWindow.location.href = url;
		} catch (error) {
			downloadWindow.close();
			console.error('Unable to prepare download', error);
		}
	};

	if (!attachment.id) {
		return (
			<Stack spacing={1} className="hover-toggle">
				<CircularProgress size={16} />
				<Typography sx={{ fontSize: 11 }} className="hover-subtle">{attachment.fileName}</Typography>
			</Stack>
		);
	}

	return (
		<Stack spacing={1}>
			<AttachmentIcon sx={{ fontSize: 16 }} />
			<Link sx={{ fontSize: 11 }} onClick={(e) => download(e)} component="button" type="button" className="pointer">{attachment.fileName}</Link>
		</Stack>
	);
}